import { defineComponent as _defineComponent } from 'vue'
import { callKBApp } from '@/hooks/use-call-kbapp'
import { computed, onMounted } from 'vue'


export default /*#__PURE__*/_defineComponent({
  __name: 'open-app',
  props: {
    extInfo: null
  },
  setup(__props: any) {

const props = __props as {
    extInfo: { action?: string; actionParams?: any }
}



const stringExtInfo = computed(() => JSON.stringify(props.extInfo))

onMounted(() => {
    const btn = document.getElementById('launch-btn')
    btn.addEventListener('launch', function(e) {
        console.log('success')
    })
    btn.addEventListener('error', function(e) {
        callKBApp(props.extInfo)
    })
})

return { __sfc: true,props, stringExtInfo }
}

})